import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

import PropTypes from "prop-types";
import React from "react";

const useStyles = makeStyles(() => ({
  content: {
    padding: "15px 20px",
    "&:not(:first-child)": {
      marginTop: "16px",
    },
  },
  header: {
    paddingBottom: "15px",
    "&:not(:first-child)": {},
  },
  "@media all and (min-width: 1024px)": {
    content: {
      "&:not(:first-child)": {
        marginTop: "30px",
      },
    },
  },
}));

function PageBody(props) {
  const classes = useStyles();
  return (
    <Paper elevation={2} className={classes.content}>
      {props.title && (
        <div className={classes.header}>
          <Typography variant="h6">{props.title}</Typography>
        </div>
      )}
      {props.children}
    </Paper>
  );
}

PageBody.defaultProps = {
  title: "",
};

PageBody.propTypes = {
  title: PropTypes.string,
};

export default PageBody;
